export default "__VITE_ASSET__DFnlAr3o__"